import { type CurrentRefinementsConnectorParamsItem } from 'instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements';

import { type RequestContext } from '~/vendor/cx-web/domain-types';

import { type EsIndex } from '../types';

export interface BettingInsightsSortingConfig<_TIndex extends EsIndex = EsIndex> {
  canSort: (data: { refinements: CurrentRefinementsConnectorParamsItem[] }) => boolean;
}

/**
 * Factory function to create BettingInsightsSorting configuration (functional approach)
 * @param requestContext - The request context
 * @param config - The sorting configuration
 * @returns Immutable sorting configuration object
 */
export function createBettingInsightsSorting<TIndex extends EsIndex>(
  requestContext: RequestContext,
  config: BettingInsightsSortingConfig<TIndex>,
) {
  return Object.freeze({
    // Context properties
    environment: requestContext.environment,
    featureFlags: requestContext.featureFlags,
    repubConfig: requestContext.repubConfig,
    user: requestContext.user,

    // Config properties
    canSort: config.canSort,
  });
}
